// import React, { useState } from "react";
import uniqid from "uniqid";
import GitHubIcon from "@mui/icons-material/GitHub";
import LanguageIcon from '@mui/icons-material/Language';
import AndroidIcon from '@mui/icons-material/Android';
import LaunchIcon from "@mui/icons-material/Launch";
import "./ProjectContainer.scss";
// import image from "/project2a.JPG"

const ProjectContainer = ({ project }) => {
  return (
    <div
      className="project reveal " data-content={project.description}
    >
      <h3>{project.name}</h3>
        {project.image && (
          <div
            id="carouselExampleSlidesOnly"
            className="projectcarousel slide"
            data-bs-ride="carousel"
          >
          <div className="carousel-inner">
            
              {project.image.map((item) => (
                <div key={uniqid()} className="carousel-item active">
                  <img src={item } className="d-block w-100" alt="..." />
                </div>
              ))}
            </div>
          </div>
        )}
      

      <div className="project_footer">
        {project.stack && (
          <ul className="project__stack">
            {project.stack.map((item) => (
              <li key={uniqid()} className="project__stack-item">
                {item}
              </li>
            ))}
          </ul>
        )}

        {project.sourceCode && (
          <a
            href={project.sourceCode}
            aria-label="source code"
            className="link link--icon"
            target="_blank"  rel="noreferrer"
          >
            <GitHubIcon />
          </a>
        )}

        {project.livePreview && (
          <a
            href={project.livePreview}
            aria-label="live preview"
            className="link link--icon"
            target="_blank"  rel="noreferrer"
          >
            <LanguageIcon />
          </a>
        )}
        {project.downloadAPP && (
          <a
            href={project.downloadAPP}
            aria-label="download app"
            className="link link--icon"
            target="_blank"  rel="noreferrer"
          >
            <AndroidIcon />
          </a>
        )}
        {project.live && (
          <a
            href={project.live}
            aria-label="download app"
            className="link link--icon"
            target="_blank"  rel="noreferrer"
          >
            <LaunchIcon />
          </a>
        )}
      </div>
    </div>
  );
};

export default ProjectContainer;
